<template>
  <div class="accordion">
    <ul class="accordion__list">
      <li
        v-for="(item, index) in items"
        :key="index"
        data-aos="fade-up"
        :data-aos-delay="index * 100 + 100"
      >
        <div class="accordion-item">
          <button
            type="button"
            :aria-expanded="activeItem === index"
            :aria-controls="`accordion-content-${_uid}-${index}`"
            :id="`accordion-button-${_uid}-${index}`"
            class="accordion-item__btn"
            :class="{ _active: activeItem === index }"
            @click.prevent="toggle(index)"
          >
            <span>{{ item.title }}</span>

            <img
              src="@/assets/landing/angle.svg"
              alt=""
              loading="lazy"
              role="presentation"
            />
          </button>

          <div
            class="accordion-item__content"
            :class="{ _active: activeItem === index }"
            :id="`accordion-content-${_uid}-${index}`"
            role="region"
            :aria-labelledby="`accordion-button-${_uid}-${index}`"
          >
            <div class="accordion-item__content-inner">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import component from '@/mixins/component';

export default {
  name: 'accordion',
  mixins: [component],
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeItem: null
    };
  },
  methods: {
    toggle(index) {
      this.activeItem = this.activeItem === index ? null : index;
    }
  }
};
</script>
